import {useEffect, useMemo} from 'react'

import {RootState} from '../store/Store'
import {setCurrentAccount} from '../slices/accountSlice'
import {usersAPI} from '../services/UsersService'
import {IAccount} from '../types'
import {useAppDispatch, useAppSelector} from './redux'

export type AccountRole = 'OWNER' | 'SUPERVISOR' | 'AGENT'

export const useAccount = () => {
  const dispatch = useAppDispatch()
  const {data: currentUser, isSuccess} = usersAPI.useFetchGetMeQuery()
  const currentAccountId = useAppSelector((state: RootState) => state.account.currentAccountId)

  const accounts: IAccount[] = useMemo(() => currentUser?.account ?? [], [currentUser])

  useEffect(() => {
    if (isSuccess && currentUser && accounts.length > 0 && !currentAccountId) {
      dispatch(setCurrentAccount(accounts[0].id))
    }
  }, [isSuccess, currentUser, accounts, currentAccountId, dispatch])

  const currentAccount = useMemo(
    () => accounts.find((a) => a.id === currentAccountId) ?? accounts[0],
    [accounts, currentAccountId]
  )

  const currentAccountIdForRequest = currentAccountId === accounts[0]?.id ? undefined : currentAccountId

  const role: AccountRole | undefined = currentAccount?.role

  return {
    accounts,
    currentAccountId,
    currentAccountIdForRequest,
    currentAccount,
    role,
    isAccount: currentUser?.is_account === true,
    isOwner: role === 'OWNER',
    isSupervisor: role === 'SUPERVISOR',
    isAgent: role === 'AGENT',
  }
}
